import { render } from "./Workcenters.vue?vue&type=template&id=34a141a1&scoped=true"
import script from "./Workcenters.vue?vue&type=script&lang=ts"
export * from "./Workcenters.vue?vue&type=script&lang=ts"

import "./Workcenters.vue?vue&type=style&index=0&id=34a141a1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34a141a1"

export default script